import { LatestContractDtoFragment, LatestContractDto } from '../../../../types'

export const retrieveContractStartAndEndDateFromContract = (contract?: LatestContractDtoFragment | LatestContractDto | null): string[] => {
  const contractStartDate = contract ? contract.validFrom : null
  let contractEndDate = contract ? contract.validTo : null
  if (contract && !contractEndDate && contract.cancellationTo) {
    contractEndDate = contract.cancellationTo
  }

  return [contractStartDate, contractEndDate] as string[]
}
